import React, { useEffect, useState, useCallback } from 'react';
import { Card, Form, Row, Col, Button } from 'react-bootstrap';
import PageHeader from 'shared/page-header';
import Layout from '../../wrappers/layout';
import IndicatorCard from './components/indicator-card';
import { userStore } from '../../store/UserStore';
import Loader from '../../shared/common/loader';
import CustomerOnboardingHttp from './services/customer.service';
import authentication from './../../Redux/auth/auth.reducer';
import OtpInput from 'react-otp-input';
import Imodal from 'shared/common/modal';
import CustomerCreatePage from './components/create_customer';
import SelectGstin from './components/select_gstin';
import OtpModal from 'shared/common/modal/otp_modal';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import Toast from 'shared/common/toast';
import SubAccountCreatePage from './components/create_sub_account';

interface PropsType {}

const CustomerOnboardingPage: React.FC<PropsType> = () => {
  // eslint-disable-next-line
  const [user, setUser] = userStore((state: any) => [
    state.user,
    state.setUser,
  ]);

  const [loading, setLoading] = useState<any>(false);
  const [customer, setCustomer] = useState<any>({
    account_type: 'IND',
    pan_number: '',
    aadhaar_number: '',
    aadhaar_aggree: false,
    name: '',
  });
  const [children, setChildren] = useState<any>();
  const [otp, setOtp] = useState<any>();
  const [state, setState] = useState<any>(0);
  const [resend, setResend] = useState(false);
  const [userName, setUserName] = useState<any>();
  const [modalShow, setModalShow] = React.useState(false);
  const [isNext, setIsNext] = React.useState(false);
  const [isUnregitered, setUnregitered] = React.useState(false);
  const [error, setError] = React.useState('');
  const history = useHistory();
  const [gstnList, setGstnList] = useState<any>([]);
  const [isSubAccount, setSubAccount] = useState(false);

  useEffect((): any => {
    setLoading(false);
    // setIsNext(true);
    // eslint-disable-next-line
  }, []);

  const onAadhaarSuccess = useCallback(async (otp) => {
    setOtp(otp);
    try {
      const data = {
        otp: otp,
        aadhaarNo: customer.aadhaar_number,
      };

      const res: any = await CustomerOnboardingHttp.verifyAadhaarOtp(data,user?.userId);
      if (res.status === 200 && res.data.data) {
        setModalShow(false);
        createIndCustomer();
      }
    } catch (e: any) {
      console.log(e.message);
    }
  }, []);

  const createAccount = (cus) => {
    if (cus.customerCategory === 'UNREGISTERED') {
      setUnregitered(true);
      // history.push('/customers');
    } else {
      setIsNext(true);
    }
    setCustomer(cus);
  };

  const aadhaarVerify = async (cus) => {
    try {
      const data = {
        name: cus.name,
        aadhaarNo: cus.aadhaar_number,
        consent: true,
        user_id:user?.userId

      };
      setCustomer(cus);
      const res: any = await CustomerOnboardingHttp.sendAadhaarOtp(data,user?.userId);
    

      if (res.status === 200 && res.data.data) {
        setModalShow(true);
      } else {
        toast.error('Something went wrong');
      }
    } catch (e: any) {
      console.log(e);

      toast.error('Something went wrong');
    }
  };

  const getGstn = async (customerId, panNumber) => {
    try {
      const data = {
        customerId: customerId,
        pan: panNumber,
      };
      const res: any = await CustomerOnboardingHttp.getGstns(data);
      if (res.status === 200 && res.data.data) {
        setGstnList(res.data.data.gstins);
      } else {
        toast.error('Something went wrong');
      }
    } catch (e: any) {
      console.log(e);

      toast.error('Something went wrong');
    }
  };

  const createIndCustomer = async () => {
    try {
      const customer_data = {
        customerType: 'IND',
        kyc: {},
      };
      const cus_res: any = await CustomerOnboardingHttp.createCustomer(
        customer_data,
        user?.userId
      );
      if (cus_res.status === 200 && cus_res.data) {
        const account_data = {
          customerId: cus_res.data.customerId,
          displayName: customer.name,
        };
        const acc_res: any = await CustomerOnboardingHttp.createAccount(
          account_data,
          user?.userId
        );
        history.push('/customers');
      }
    } catch (e: any) {
      console.log(e.message);
    }
  };

  const resendOtp = () => {
    aadhaarVerify(customer);
    setResend(false);
  };

  if (!isUnregitered) {
    return (
      <Layout isLinkShow={false}>
        {/*<Toast/>*/}
        {isNext ? (
          <SelectGstin
            customerId={customer?.customerId}
            pan={customer?.kyc?.pan?.value}
          />
        ) : (
          <CustomerCreatePage
            handleCreate={(cust) => createAccount(cust)}
            apiError={error}
          />
        )}

        <OtpModal
          show={modalShow}
          handleClose={() => setModalShow(false)}
          title={'OTP is sent to Aadhaar registered mobile number'}
          onSuccess={(otp) => onAadhaarSuccess(otp)}
          resend={resendOtp}
        />
      </Layout>
    );
  } else {
    return (
      <Layout isLinkShow={false}>
        {/*<Toast/>*/}
        {isNext ? (
          <SelectGstin
            customerId={customer?.customerId}
            pan={customer?.kyc?.pan?.value}
          />
        ) : (
          <SubAccountCreatePage customerId={customer?.customerId}   />
        )}

        <OtpModal
          show={modalShow}
          handleClose={() => setModalShow(false)}
          title={'Enter the OTP sent your Aadhar registered Mobile Number'}
          onSuccess={(otp) => onAadhaarSuccess(otp)}
          resend={resendOtp}
        />
      </Layout>
    );
  }
};

export default CustomerOnboardingPage;
